import dayjs, {Dayjs} from "dayjs";
import isLeapYear from "dayjs/plugin/isLeapYear";

dayjs.extend(isLeapYear);

export const nextYearMinusDay = (date: string | Dayjs): Dayjs => {
    const inputDate = dayjs(date);

    let endDate: Dayjs = inputDate.add(1, "year").subtract(1, "day");

    if (inputDate.isLeapYear() && inputDate.month() === 1 && inputDate.date() === 29) {
        endDate = endDate.subtract(1, "day");
    }

    return endDate;
};

/**
 * Formats a "short" locale-specific date, for example "17/04/2024" for EU region, "04/17/2024" for US
 */
export const formatShortDate = (date: Dayjs, format: string): string => {
    return date.format(format);
};

export const formatShortDataEmpty = (date: Dayjs | null | undefined, format: string): string => {
    if (date) {
        return formatShortDate(date, format);
    } else {
        return "";
    }
};
/**
 * Formats a "long" locale-specific date, for example "Wed 17/04/2024" for EU region, "Wed 04/17/2024" for US
 */
export const formatLongDate = (date: Dayjs, format: string): string => {
    return `${date.format("ddd")} ${formatShortDate(date, format)}`;
};

/**
 * Formats a "short" locale-specific date and time, for example "17/04/2024 12:34" for EU region, "04/17/2024 12:34" for US
 */
export const formatShortDateTime = (dateTime: Dayjs, format: string): string => {
    return dateTime.format(format);
};

/**
 * Formats a Dayjs object to ISO 8601 UTC ignoring browser timezone.
 * Used to send direct UTC datetime picker date to the backend.
 */
export const formatToISO8601 = (date: Dayjs) => date.format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
